import React from "react";

import Pagination from "react-bootstrap/Pagination";

import "./pagination.styles.scss";

function CustomPagination({
  totalPages,
  paginate,
  currentPage,
  hasNextPage,
  hasPrevPage,
}) {
  const pageNumbers = [];
  console.log(totalPages);

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <Pagination>
      <Pagination.Prev
        onClick={() => {
          if (hasPrevPage) {
            paginate(currentPage - 1);
            window.scrollTo(0, 0);
          }
        }}
        disabled={!hasPrevPage}
      />

      {pageNumbers.map((number) => (
        <Pagination.Item
          key={number}
          onClick={() => {
            paginate(number);
            window.scrollTo(0, 0);
          }}
          active={currentPage === number}
        >
          {number}
        </Pagination.Item>
      ))}

      <Pagination.Next
        onClick={() => {
          if (hasNextPage) {
            paginate(currentPage + 1);
            window.scrollTo(0, 0);
          }
        }}
        disabled={!hasNextPage}
      />
    </Pagination>
  );
}

export default CustomPagination;
